import styled from 'styled-components'

export const ContainerAdjuvante = styled.div`
  width: 100%;
  height: calc(100% - 10px);
  box-sizing: border-box;
  padding: 5px;
  overflow: hidden;
`